/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import Header from "../../views/layout/Header";
import Sidebar from "../../views/layout/Sidebar";
import ComponentSidebar from "../../components/ComponentSidebar";
import SettingsSidebar from "../../components/SettingsSidebar";
import EmployeeDashboard from "../../views/pages/MainPages/Dashboard/EmployeeDashboard";
import Settings from "../../views/pages/Administration/Settings/Settings";
import Localization from "../../views/pages/Administration/Settings/Localization";
import ThemeSettings from "../../views/pages/Administration/Settings/ThemeSettings";
import RolesPermissions from "../../views/pages/Administration/Settings/RolesPermissions";
import EmailSettings from "../../views/pages/Administration/Settings/EmailSettings";
import PerformanceSetting from "../../views/pages/Administration/Settings/Performance/PerformanceSetting";
import ApprovalSetting from "../../views/pages/Administration/Settings/ApprovalSetting";
import InvoiceSettings from "../../views/pages/Administration/Settings/InvoiceSettings";
import SalarySettings from "../../views/pages/Administration/Settings/SalarySettings";
import NotificationSettings from "../../views/pages/Administration/Settings/NotificationSettings";
import LeaveType from "../../views/pages/Administration/Settings/LeaveType";
import ToxboxSetting from "../../views/pages/Administration/Settings/ToxboxSetting";
import CronSetting from "../../views/pages/Administration/Settings/CronSetting";
import Clients from "../../views/pages/Employees/Clients";
import Leads from "../../views/pages/Employees/Leads";
import Profile from "../../views/pages/Profile/Profile";
import Assets from "../../views/pages/Administration/Assets";
import UserDashboard from "../../views/pages/Administration/Jobs/UserJob/UserDashboard";
import UserAllJobs from "../../views/pages/Administration/Jobs/UserJob/UserAllJobs";
import SavedJobs from "../../views/pages/Administration/Jobs/UserJob/SavedJobs";
import AppliedJobs from "../../views/pages/Administration/Jobs/UserJob/AppliedJobs";
import Interviewing from "../../views/pages/Administration/Jobs/UserJob/Interviewing";
import JobAptitude from "../../views/pages/Administration/Jobs/UserJob/JobAptitude";
import Questions from "../../views/pages/Administration/Jobs/UserJob/Questions";
import UserOfferedJobs from "../../views/pages/Administration/Jobs/UserJob/UserOfferedJobs";
import VisitedJobs from "../../views/pages/Administration/Jobs/UserJob/VisitedJobs";
import ArchivedJobs from "../../views/pages/Administration/Jobs/UserJob/ArchivedJobs";
import JobsDashboard from "../../views/pages/Administration/Jobs/JobDashboard";
import ManageJobs from "../../views/pages/Administration/Jobs/ManageJobs";
import ManageJobResumes from "../../views/pages/Administration/Jobs/ManageResumes";
import ShortListCandidates from "../../views/pages/Administration/Jobs/ShortListCandidates";
import InterviewingQuestions from "../../views/pages/Administration/Jobs/InterviewingQuestions";
import OfferApprovals from "../../views/pages/Administration/Jobs/OfferApprovals";
import ExperienceLevel from "../../views/pages/Administration/Jobs/ExperienceLevel";
import CanditatesList from "../../views/pages/Administration/Jobs/CanditatesList";
import ScheduleTiming from "../../views/pages/Administration/Jobs/ScheduleTiming.jsx";
import AptitudeResults from "../../views/pages/Administration/Jobs/AptitudeResults";
import Users from "../../views/pages/Administration/Users";
import OffCanvas from "../../components/OffCanvas";
import BrokerList from "../../views/pages/Employees/BrokerList.jsx";
import PropertyList from "../../views/pages/Employees/PropertyList.jsx";
import BTBankList from "../../views/pages/Employees/BTBankList.jsx";
import CollectionList from "../../views/pages/Employees/CollectionList.jsx";
import ResidenceList from "../../views/pages/Employees/ResidenceList.jsx";
import FileLoginList from "../../views/pages/Employees/FileLoginList.jsx";
import MarketingList from "../../views/pages/Employees/MarketingList.jsx";
import BuisnessPDList from "../../views/pages/Employees/BuisnessPDList.jsx";
import ChannelpartnerList from "../../views/pages/Employees/ChannelpartnerList.jsx";
import COllectionOFIMDList from "../../views/pages/Employees/COllectionOFIMDList.jsx";
import DocumentCollectionList from "../../views/pages/Employees/DocumentCollectionList.jsx";
import OTCClearanceList from "../../views/pages/Employees/OTCClearanceList.jsx";
import CollectionOfEMIList from "../../views/pages/Employees/CollectionOfEMIList.jsx";
import VendorList from "../../views/pages/Employees/VendorList.jsx";
import CustomerList from "../../views/pages/Employees/CustomerList..jsx";
import BankList from "../../views/pages/Employees/BankList.jsx";

import DeskList from "../../views/pages/Employees/DeskList.jsx";
import AuthorityPageFilter from "../../views/pages/Employees/AuthorityPageFilter.jsx";
import LeadsList from "../../views/pages/Employees/LeadsList.jsx";
import TeamsList from "../../views/pages/Employees/TeamsList.jsx";
import MyActivitiesPage from "../../views/pages/Employees/MyActivitiesPage.jsx";
import AddBusinessPd from "../../views/pages/Employees/AddBusinessPd.jsx";
import MainLayoutProfile from "../../components/Profiles/MainLayoutProfile.jsx";
import GarageAutoSingleUser from "../../components/Profiles/GarageAutoSingleUser.jsx";
import FlourMillDataDetails from "../../components/Profiles/FlourMillDataDetails.jsx";
import GarmentBuisnessDetails from "../../components/Profiles/GarmentBuisnessDetails.jsx";
import JuiceCeneterdetails from "../../components/Profiles/JuiceCeneterdetails.jsx";
import GroceryStoreDetails from "../../components/Profiles/GroceryStoreDetails.jsx";
import SaloonProfileDetails from "../../components/Profiles/SaloonProfileDetails.jsx";
import SweetShopDEtails from "../../components/Profiles/SweetShopDEtails.jsx";
import TailorShopDetails from "../../components/Profiles/TailorShopDetails.jsx";
import TeaStallProfileDetails from "../../components/Profiles/TeaStallProfileDetails.jsx";
import TentHouseDetails from "../../components/Profiles/TentHouseDetails.jsx";
import VegetableShopDetails from "../../components/Profiles/VegetableShopDetails.jsx";
import DairyShopDEtails from "../../components/Profiles/DairyShopDEtails.jsx";
import SweetShopAllDetails from "../../components/Profiles/SweetShopAllDetails.jsx";
import BuisnessPdEmployeeDetails from "../../views/pages/Employees/BuisnessPdEmployeeDetails.jsx";
import CateringBuisnessDetails from "../../components/Profiles/CateringBuisnessDetails.jsx";
import AddExpenses from "../../components/Profiles/AddExpenses.jsx";
import UserEmployeePage from "../../views/pages/Employees/UserEmployeePage.jsx";
import ActivitiesPage from "../../views/pages/Employees/ActivitiesPage.jsx";
import PdAssestSInglePage from "../../views/pages/Employees/PdAssestSInglePage.jsx";
import CashFlowDataSinglePage from "../../views/pages/Employees/CashFlowDataSinglePage.jsx";
import BuisnessPDsingleAllInformation from "../../views/pages/Employees/BuisnessPDsingleAllInformation.jsx";
import DairyDetails from "../../views/pages/Employees/BuisnessPdDetails/DairyDetails.jsx";
import PreviousPage from "../../components/Profiles/PreviousPage.jsx";
import ActivityReportsPage from "../../views/pages/Employees/ActivityReportsPage.jsx";
import TeamsReportsPage from "../../views/pages/Employees/TeamsReportsPage.jsx";
import TestingList from "../../views/pages/Employees/PreDisbursalCollectionVisit.jsx";
import PreDisbursalCollectionVisitList from "../../views/pages/Employees/PreDisbursalCollectionVisit.jsx";
import GeneralList from "../../views/pages/Employees/GeneralList.jsx";
import { BranchClosing } from "../../views/pages/Employees/BranchClosing.jsx";
import { BranchOpening } from "../../views/pages/Employees/BranchOpening.jsx";
import { CustomerFeedback } from "../../views/pages/Employees/CustomerFeedback.jsx";
import { ItInventory } from "../../views/pages/Employees/ItInventory.jsx";
import { BranchIssue } from "../../views/pages/Employees/BranchIssue.jsx";
import { BranchAssets } from "../../views/pages/Employees/BranchAssets.jsx";
import { FileStorage } from "../../views/pages/Employees/FileStorage.jsx";
import { FileMovement } from "../../views/pages/Employees/FileMovement.jsx";

const AppContainer = () => {
  useEffect(() => {
    localStorage.setItem("colorschema", "blue");
    localStorage.setItem("layout", "vertical");
    localStorage.setItem("layoutwidth", "fixed");
    localStorage.setItem("layoutpos", "fluid");
    localStorage.setItem("topbartheme", "light");
    localStorage.setItem("layoutSized", "lg");
    localStorage.setItem("layoutStyling", "default");
    localStorage.setItem("layoutSidebarStyle", "dark");
  }, []);

  const routingObjects = [
    {
      id: 1,
      path: "employee-dashboard",
      element: <EmployeeDashboard />,
    },
    {
      id: 2,
      path: "clients",
      element: <Clients />,
    },
    {
      id: 3,
      path: "leads",
      element: <Leads />,
    },
    {
      id: 4,
      path: "profile",
      element: <Profile />,
    },
    {
      id: 5,
      path: "leads-list",
      element: <LeadsList />,
    },
    {
      id: 7,
      path: "collection-visit",
      element: <CollectionList />,
    },
    {
      id: 8,
      path: "authority-visit",
      element: <AuthorityPageFilter />,
    },
    {
      id: 9,
      path: "bt-bank-visit",
      element: <BTBankList />,
    },
    {
      id: 10,
      path: "property-visit",
      element: <PropertyList />,
    },
    {
      id: 11,
      path: "broker-visit",
      element: <BrokerList />,
    },
    {
      id: 12,
      path: "desk-work",
      element: <DeskList />,
    },
    {
      id: 13,
      path: "bank",
      element: <BankList />,
    },
    {
      id: 14,
      path: "customer",
      element: <CustomerList />,
    },
    {
      id: 15,
      path: "vendor-visit",
      element: <VendorList />,
    },
    {
      id: 16,
      path: "bt-bank-visit",
      element: <BTBankList />,
    },
    {
      id: 17,
      path: "leads",
      element: <LeadsList />,
    },
    {
      id: 18,
      path: "collection",
      element: <CollectionOfEMIList />,
    },
    {
      id: 19,
      path: "otc-clearance",
      element: <OTCClearanceList />,
    },
    {
      id: 20,
      path: "document-collection",
      element: <DocumentCollectionList />,
    },
    {
      id: 21,
      path: "imdcollection",
      element: <COllectionOFIMDList />,
    },
    {
      id: 22,
      path: "channel-partners",
      element: <ChannelpartnerList />,
    },
    {
      id: 23,
      path: "buisness-pd",
      element: <BuisnessPDList />,
    },
    {
      id: 24,
      path: "marketing-activity",
      element: <MarketingList />,
    },
    {
      id: 25,
      path: "file-login",
      element: <FileLoginList />,
    },
    {
      id: 26,
      path: "residense-pd",
      element: <ResidenceList />,
    },
    {
      id: 27,
      path: "teams",
      element: <TeamsList />,
    },
    {
      id: 28,
      path: "teams/activities/:id",
      element: <MyActivitiesPage />,
    },
    {
      id: 29,
      path: "buisness-pd/add",
      element: <AddBusinessPd />,
    },
    {
      id: 30,
      path: "buisness-pd/add/view-profile",
      element: <MainLayoutProfile />,
    },
    {
      id: 31,
      path: "buisness-pd/add/view-profile/details/:id",
      element: <GarageAutoSingleUser />,
    },
    {
      id: 32,
      path: "buisness-pd/add/view-profile/flourdetails/:id",
      element: <FlourMillDataDetails />,
    },
    {
      id: 33,
      path: "buisness-pd/add/view-profile/garmentdetails/:id",
      element: <GarmentBuisnessDetails />,
    },
    {
      id: 34,
      path: "buisness-pd/add/view-profile/juicecenterdetails/:id",
      element: <JuiceCeneterdetails />,
    },
    {
      id: 35,
      path: "buisness-pd/add/view-profile/grocerydetails/:id",
      element: <GroceryStoreDetails />,
    },
    {
      id: 36,
      path: "buisness-pd/add/view-profile/saloondetails/:id",
      element: <SaloonProfileDetails />,
    },
    {
      id: 37,
      path: "buisness-pd/add/view-profile/sweetsdetails/:id",
      element: <SweetShopDEtails />,
    },
    {
      id: 38,
      path: "buisness-pd/add/view-profile/tailordetails/:id",
      element: <TailorShopDetails />,
    },
    {
      id: 39,
      path: "buisness-pd/add/view-profile/teastalldetails/:id",
      element: <TeaStallProfileDetails />,
    },
    {
      id: 40,
      path: "buisness-pd/add/view-profile/TentHouseDetails/:id",
      element: <TentHouseDetails />,
    },
    {
      id: 41,
      path: "buisness-pd/add/view-profile/vegetablesdetails/:id",
      element: <VegetableShopDetails />,
    },
    {
      id: 42,
      path: "buisness-pd/add/view-profile/dairydetails/:id",
      element: <DairyShopDEtails />,
    },
    {
      id: 43,
      path: "buisness-pd/add/view-profile/sweetsdetails/:id/rawmaterial/:itemId",
      element: <SweetShopAllDetails />,
    },
    {
      id: 44,
      path: "buisness-pd/details/:id",
      element: <BuisnessPdEmployeeDetails />,
    },
    {
      id: 45,
      path: "buisness-pd/add/view-profile/catering/:id",
      element: <CateringBuisnessDetails />,
    },
    {
      id: 46,
      path: "buisness-pd/add/view-profile/expenses/:id",
      element: <AddExpenses />,
    },
    {
      id: 47,
      path: "employee-data",
      element: <UserEmployeePage />,
    },
    {
      id: 48,
      path: "Check-activities",
      element: <ActivitiesPage />,
    },
    {
      id: 49,
      path: "buisness-pd/add/assestdetails/:id",
      element: <PdAssestSInglePage />,
    },
    {
      id: 50,
      path: "buisness-pd/add/cashFlowdetails/:id",
      element: <CashFlowDataSinglePage />,
    },
    {
      id: 51,
      path: "buisness-pd/details/:id/allinfodetails/:id",
      element: <BuisnessPDsingleAllInformation />,
    },
    {
      id: 52,
      path: "autodriver-details",
      element: <BuisnessPDsingleAllInformation />,
    },
    {
      id: 53,
      path: "dairy-details",
      element: <DairyDetails />,
    },
    {
      id: 54,
      path: "activity-reports",
      element: <ActivityReportsPage />,
    },
    {
      id: 55,
      path: "team-reports",
      element: <TeamsReportsPage />,
    },
    {
      id: 56,
      path: "pre-disbursal-collection-visit",
      element: <PreDisbursalCollectionVisitList />,
    },
    {
      id: 57,
      path: "general-pd",
      element: <GeneralList />,
    },
    {
      id: 58,
      path: "branch-closing",
      element: <BranchClosing />,
    },
    {
      id: 59,
      path: "branch-opening",
      element: <BranchOpening />,
    },
    {
      id: 60,
      path: "customer-feedback",
      element: <CustomerFeedback />,
    },
    {
      id: 61,
      path: "it-inventory",
      element: <ItInventory />,
    },
    {
      id: 61,
      path: "branch-issue",
      element: <BranchIssue />,
    },
    {
      id: 62,
      path: "branch-assets",
      element: <BranchAssets />,
    },
    {
      id: 63,
      path: "file-storage",
      element: <FileStorage />,
    },
    {
      id: 64,
      path: "file-movement",
      element: <FileMovement />,
    },
  ];

  // const ChatRoutingeObjects = [
  //   {
  //     id: 1,
  //     path: "chat",
  //     element: <Chat />,
  //   },
  //   {
  //     id: 2,
  //     path: "voice-call",
  //     element: <VoiceCall />,
  //   },
  //   {
  //     id: 3,
  //     path: "video-call",
  //     element: <VideoCall />,
  //   },
  //   {
  //     id: 4,
  //     path: "outgoing-call",
  //     element: <Outgoing />,
  //   },
  //   {
  //     id: 5,
  //     path: "incoming-call",
  //     element: <IncomingCall />,
  //   },
  // ];
  // const ComponentsRoutingeObjects = [
  //   {
  //     id: 1,
  //     path: "components",
  //     element: <Components />,
  //   },
  // ];
  // const EmailRoutingeObjects = [
  //   {
  //     id: 1,
  //     path: "inbox",
  //     element: <Email />,
  //   },
  //   {
  //     id: 2,
  //     path: "compose",
  //     element: <Compose />,
  //   },
  //   {
  //     id: 3,
  //     path: "mail-view",
  //     element: <EmailView />,
  //   },

  // ];

  const SettingsRoutingeObjects = [
    {
      id: 1,
      path: "company-settings",
      element: <Settings />,
    },
    {
      id: 2,
      path: "localization",
      element: <Localization />,
    },
    {
      id: 3,
      path: "theme-settings",
      element: <ThemeSettings />,
    },
    {
      id: 4,
      path: "roles-permissions",
      element: <RolesPermissions />,
    },
    {
      id: 5,
      path: "email-settings",
      element: <EmailSettings />,
    },
    {
      id: 6,
      path: "performance-setting",
      element: <PerformanceSetting />,
    },
    {
      id: 7,
      path: "approval-setting",
      element: <ApprovalSetting />,
    },
    {
      id: 8,
      path: "invoice-settings",
      element: <InvoiceSettings />,
    },
    {
      id: 9,
      path: "salary-settings",
      element: <SalarySettings />,
    },
    {
      id: 10,
      path: "notifications-settings",
      element: <NotificationSettings />,
    },
    {
      id: 11,
      path: "leave-type",
      element: <LeaveType />,
    },
    {
      id: 14,
      path: "toxbox-setting",
      element: <ToxboxSetting />,
    },
    {
      id: 15,
      path: "cron-setting",
      element: <CronSetting />,
    },
  ];

  // const ProjectRoutingeObjects = [
  //   {
  //     id: 1,
  //     path: "tasks",
  //     element: <Tasks />,
  //   },
  // ];

  const AdministrationRoutingeObjects = [
    {
      id: 1,
      path: "assets",
      element: <Assets />,
    },
    {
      id: 2,
      path: "user-dashboard",
      element: <UserDashboard />,
    },
    {
      id: 3,
      path: "user-all-jobs",
      element: <UserAllJobs />,
    },
    {
      id: 4,
      path: "saved-jobs",
      element: <SavedJobs />,
    },
    {
      id: 5,
      path: "applied-jobs",
      element: <AppliedJobs />,
    },

    {
      id: 6,
      path: "interviewing",
      element: <Interviewing />,
    },
    {
      id: 7,
      path: "job-aptitude",
      element: <JobAptitude />,
    },
    {
      id: 8,
      path: "questions",
      element: <Questions />,
    },
    {
      id: 9,
      path: "offered-jobs",
      element: <UserOfferedJobs />,
    },
    {
      id: 10,
      path: "visited-jobs",
      element: <VisitedJobs />,
    },
    {
      id: 11,
      path: "archived-jobs",
      element: <ArchivedJobs />,
    },
    {
      id: 12,
      path: "jobs-dashboard",
      element: <JobsDashboard />,
    },
    {
      id: 13,
      path: "jobs",
      element: <ManageJobs />,
    },
    {
      id: 14,
      path: "manage-resumes",
      element: <ManageJobResumes />,
    },
    {
      id: 15,
      path: "shortlist-candidates",
      element: <ShortListCandidates />,
    },
    {
      id: 16,
      path: "interview-questions",
      element: <InterviewingQuestions />,
    },
    {
      id: 17,
      path: "offer_approvals",
      element: <OfferApprovals />,
    },
    {
      id: 18,
      path: "experiance-level",
      element: <ExperienceLevel />,
    },
    {
      id: 19,
      path: "candidates",
      element: <CanditatesList />,
    },
    {
      id: 21,
      path: "schedule-timing",
      element: <ScheduleTiming />,
    },
    {
      id: 22,
      path: "apptitude-result",
      element: <AptitudeResults />,
    },
    {
      id: 23,
      path: "users",
      element: <Users />,
    },
  ];

  const SidebarLayout = () => (
    <>
      <Header />
      <Sidebar />
      <OffCanvas />
      <Outlet />
    </>
  );
  const AuthendicationLayout = () => <div></div>;
  const ChatSidebarLayout = () => (
    <>
      <Header />
      {/* <ChatSidebar /> */} ------ Comment By Deepak
      <Outlet />
    </>
  );
  const ComponentSidebarLayout = () => (
    <>
      <Header />
      <ComponentSidebar />
      <Outlet />
    </>
  );
  const EmailSidebarLayout = () => (
    <>
      <Header />
      {/* <EmailSidebar /> */} ------ Comment By Deepak
      <Outlet />
    </>
  );
  const SettingsSidebarLayout = () => (
    <>
      <Header />
      <SettingsSidebar />
      <Outlet />
    </>
  );
  // const ProjectSidebarLayout = () => (
  //   <>
  //     <Header />
  //     <SidebarProject />
  //     <Outlet />
  //   </>
  // );

  const mobileResponsive = (event) => {
    const excludedHeader = document.querySelector(".header");
    const excludedSidebar = document.querySelector(".sidebar");

    if (
      !excludedHeader.contains(event.target) &&
      !excludedSidebar.contains(event.target)
    ) {
      document.body.classList.remove("slide-nav");
    }
  };

  return (
    <>
      <div className="main-wrapper" onClick={mobileResponsive}>
        <Routes>
          <Route path={"/*"} element={<SidebarLayout />}>
            {routingObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>

          {/* <Route path={"/*"} element={<ChatSidebarLayout />}>
            {ChatRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route path={"/*"} element={<ComponentSidebarLayout />}>
            {ComponentsRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route path={"/*"} element={<EmailSidebarLayout />}>
            {EmailRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>*/}
          <Route path={"/*"} element={<SettingsSidebarLayout />}>
            {SettingsRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>
          {/* <Route path={"/*"} element={<ProjectSidebarLayout />}>
            {ProjectRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route> */}

          <Route path={"/*"} element={<SidebarLayout />}>
            {AdministrationRoutingeObjects.map((item) => (
              <Route key={item.id} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route path={"/*"} element={<SidebarLayout />}>
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default AppContainer;
